import EmulationBar from './EmulationBar';
import NewVersionBar from './NewVersionBar';
import MaintenanceModeBar from './MaintenanceModeBar';
import MarketStatusBanner from './MarketStatusBanner';
import ReferralBar from './ReferralBar';
import { ArbitraryStatusBar } from './ArbitraryStatusBar';
import ZeroFeesBanner from './ZeroFeesBanner';

const StatusBars = () => {
	return (
		<div className="flex flex-col gap-y-2xs">
			<ZeroFeesBanner />
			<NewVersionBar />
			<EmulationBar />
			<ReferralBar />
			<MaintenanceModeBar />
			<MarketStatusBanner />
			<ArbitraryStatusBar />
		</div>
	);
};

export default StatusBars;
